import { api } from '@/lib/api'
import type {
  CompanyBranding,
  UpdateBrandingPayload,
  LogoUploadResponse,
  DeleteLogoResponse,
  UpdateSlugResponse,
  CustomDomainDetails,
  VerifyDomainResponse,
  PreviewUrlDTO,
} from '@/types/branding.types'

export const brandingService = {
  get(companyId: string): Promise<CompanyBranding> {
    return api.get<CompanyBranding>(`/companies/${companyId}/branding`)
  },

  getPreviewUrl(companyId: string): Promise<PreviewUrlDTO> {
    return api.get<PreviewUrlDTO>(`/companies/${companyId}/branding/preview-url`)
  },

  update(companyId: string, payload: UpdateBrandingPayload): Promise<CompanyBranding> {
    return api.put<CompanyBranding>(`/companies/${companyId}/branding`, payload)
  },

  uploadLogo(companyId: string, type: 'light' | 'dark' | 'icon', file: File): Promise<LogoUploadResponse> {
    const formData = new FormData()
    formData.append('file', file)
    return api.post<LogoUploadResponse>(`/companies/${companyId}/branding/logo/${type}`, formData)
  },

  deleteLogo(companyId: string, type: 'light' | 'dark' | 'icon'): Promise<DeleteLogoResponse> {
    return api.delete<DeleteLogoResponse>(`/companies/${companyId}/branding/logo/${type}`)
  },

  getPublicBySlug(slug: string): Promise<CompanyBranding> {
    return api.get<CompanyBranding>(`/public/branding/by-slug/${encodeURIComponent(slug)}`)
  },

  getPublicByDomain(domain: string): Promise<CompanyBranding> {
    return api.get<CompanyBranding>(`/public/branding/by-domain?domain=${encodeURIComponent(domain)}`)
  },

  updateSlug(companyId: string, slug: string): Promise<UpdateSlugResponse> {
    return api.put<UpdateSlugResponse>(`/companies/${companyId}/branding/slug`, { slug })
  },

  getDomainDetails(companyId: string): Promise<CustomDomainDetails> {
    return api.get<CustomDomainDetails>(`/companies/${companyId}/branding/domain`)
  },

  updateDomain(companyId: string, customDomain: string | null): Promise<any> {
    return api.put<any>(`/companies/${companyId}/branding/domain`, { custom_domain: customDomain })
  },

  verifyDomain(companyId: string): Promise<VerifyDomainResponse> {
    return api.post<VerifyDomainResponse>(`/companies/${companyId}/branding/domain/verify`, {})
  },

  deleteDomain(companyId: string): Promise<any> {
    return api.delete<any>(`/companies/${companyId}/branding/domain`)
  },
}
